import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import VendorFormComponent from "./_form"

interface VendorForm {
  company_name: string
  first_name: string
  last_name: string
  vendor_type_id: number | null
  country_id: number | null
  address: string
  address2: string
  city: string
  state: string
  zip: string
  office_phone: string
  cell_phone: string
  fax: string
  email: string
  website: string
  notes: string
  hourly_rate: number | null
  travel_rate: number | null
  mileage_rate: number | null
  schedule: boolean
}

interface Option {
  id: number
  name: string
}

interface Props {
  vendor: VendorForm
  vendor_types: Option[]
  countries: Option[]
  errors?: Record<string, string[]>
  group?: number | null
  group_name?: string | null
}

export default function New({
  vendor,
  vendor_types,
  countries,
  errors,
  group,
  group_name,
}: Props) {
  const title = group_name
    ? `New ${group_name} Subcontractor`
    : "New Subcontractor"

  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Subcontractors", href: "/company/vendors" },
    { title: title, href: "/company/vendors/new" },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={title} />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">{title}</h1>

        <VendorFormComponent
          vendor={vendor}
          vendor_types={vendor_types}
          countries={countries}
          errors={errors}
          submitUrl="/company/vendors"
          submitMethod="post"
          group={group}
        />
      </div>
    </AppLayout>
  )
}
